import { ToastrService } from 'ngx-toastr';
import { REGEX } from './../../../@resources/validators/validator';
import { AuthService } from '../../../@resources/services/auth.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { LocalStorageService } from '../../../@resources/services/local-storage.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit {
  @Output() changeSignUp: EventEmitter<string> = new EventEmitter();
  isSubmitting = false;
  martialStatus: [] = [];
  sexes: [] = [];
  countries: any[] = [];
  doctors: any[] = [];
  patientSources: any[] = [];
  fistStep = true;
  // firstName = '';
  // lastName = '';

  signUpForm = this.fb.group({
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    national_number: ['', Validators.required],
    password: ['', [Validators.required, Validators.pattern(REGEX.password)]],
    confirm_password: [
      '',
      [Validators.required, Validators.pattern(REGEX.password)],
    ],
    phone: ['', Validators.required],
    email: ['', [Validators.email, Validators.required]],
    // doctor_p_id: ['', Validators.required],
    // sex_p: [''],
    // marital_status_p: ['', Validators.required],
    // patient_source_p_id: ['', Validators.required],
    country_id: ['', Validators.required],
    // dob_p: ['', Validators.required],
  });

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private localStorage: LocalStorageService,
    private router: Router,
    private toastrService: ToastrService
  ) {}

  ngOnInit(): void {
    this.authService.signUpParamters().subscribe((res: any) => {
      if (localStorage.getItem('lang')?.indexOf('ar') !== -1) {
        this.martialStatus = res.data.maritals[0];
        this.sexes = res.data.sexes[0];
      } else {
        this.martialStatus = res.data.maritals_en[0];
        this.sexes = res.data.sexes_en[0];
      }
      this.countries = res.data.countries;
      this.doctors = res.data.doctors;
      this.patientSources = res.data.leads;
    });
  }

  signUp() {
    // this.firstName = this.signUpForm.value.fullName.split(' ')[0]
    // this.lastName = this.signUpForm.value.fullName.split(' ')[1]
    const lang = this.localStorage.get('lang');
    const gObj = {
      // firstName: this.firstName,
      // lastName: this.lastName,
      firstName: this.signUpForm.value.firstName,
      lastName: this.signUpForm.value.lastName,
      email: this.signUpForm.value.email,
      password: this.signUpForm.value.password,
      phoneNumber: this.signUpForm.value.phone,
      national_id: this.signUpForm.value.national_number,
      country_id: this.signUpForm.value.country_id,
      confirm_password: this.signUpForm.value.confirm_password,
      // gender: this.signUpForm.value.sex_p === 'Female' ? 'FEMALE' : 'MALE',
    };
    this.isSubmitting = true;
    this.authService.gSignUp(gObj).subscribe(
      (data) => {
        this.isSubmitting = false;
        lang == 'en'
          ? this.toastrService.success(
              `Account successfully created`,
              `Sign up`
            )
          : this.toastrService.success(
              `تم انشاء الحساب بنجاح برجاء تسجيل الدخول`,
              `انشاء حساب`
            );
        this.navigateLogin();
      },
      (error) => {
        lang == 'en'
          ? this.toastrService.error(error?.message, `Cant create account`)
          : this.toastrService.error(
              error?.message,
              `غير قادر علي انشاء الحساب`
            );
        console.log(error.message);
      }
    );
    (function () {
      'use strict';
      var forms = document.querySelectorAll('.needs-validation');
      Array.prototype.slice.call(forms).forEach(function (form) {
        form.addEventListener(
          'submit',
          function (event: any) {
            if (!form.checkValidity()) {
              event.preventDefault();
              event.stopPropagation();
            }
            form.classList.add('was-validated');
          },
          false
        );
      });
    })();
    // this.authService.signUp(obj,'303').subscribe((data: any) => {
    //   if (data.result === false) {
    //     this.toastrService.error(`${data?.msg}`, ``);
    //     this.isSubmitting = false;
    //   } else {

    // }}, error => {
    // 	this.isSubmitting = false;
    // });
  }

  // public get fullName() {
  //   return this.signUpForm.get('fullName');
  // }
  public get firstName() {
    return this.signUpForm.get('firstName');
  }
  public get lastName() {
    return this.signUpForm.get('lastName');
  }
  public get national_number() {
    return this.signUpForm.get('national_number');
  }

  public get password() {
    return this.signUpForm.get('password');
  }

  public get confirm_password() {
    return this.signUpForm.get('confirm_password');
  }

  public get phone() {
    return this.signUpForm.get('phone');
  }

  public get email() {
    return this.signUpForm.get('email');
  }

  public get sex_p() {
    return this.signUpForm.get('sex_p');
  }

  public get marital_status_p() {
    return this.signUpForm.get('marital_status_p');
  }

  public get country_id() {
    return this.signUpForm.get('country_id');
  }

  public get doctor_p_id() {
    return this.signUpForm.get('doctor_p_id');
  }

  public get patient_source_p_id() {
    return this.signUpForm.get('patient_source_p_id');
  }

  public get dob_p() {
    return this.signUpForm.get('dob_p');
  }

  navigateLogin() {
    this.fistStep = true;
    this.signUpForm.reset();
    this.changeSignUp.emit('login');
  }
}
